import { Grid } from '@mui/material';
import FieldText from '../../../../../components/general/fields/fieldText';
import { PqrInFavorOfProps } from './props';
import { Accordion } from '../../../../../components/general/accordion';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import { usePqrInFavorOf } from './hook';

export const PqrInFavorOf = ({ inFavorOf }: PqrInFavorOfProps) => {
    const { formik } = usePqrInFavorOf(inFavorOf);
    return (
        <Accordion
            title="A FAVOR DE"
            icon={<DoneAllIcon sx={{ color: 'primary.main' }} />}
            defaultExpanded={false}
            mt={0}
        >
            <Grid
                container
                spacing={{ xs: 1.5, md: 1.5 }}
                columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            >
                <Grid item xs={12} sm={6}>
                    <FieldText
                        label="A favor de"
                        name="inFavorOf"
                        size="small"
                        value={formik.values.inFavorOf}
                    />
                </Grid>
            </Grid>
        </Accordion>
    );
};
